import { render, staticRenderFns } from "./SkuInfo.vue?vue&type=template&id=6064195d&scoped=true&"
import script from "./SkuInfo.vue?vue&type=script&lang=js&"
export * from "./SkuInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064195d",
  null
  
)

export default component.exports